'use strict';

const i18n = require('i18next');
const _ = require('underscore');
const Mn = require('backbone.marionette');
const Util = require('common/util');
const Snackbar = require('common/util/snackbar');
const Colors = require('common/util/material-colors');
const TypeaheadView = require('common/ui/view/typeahead');
const TagAction = require('system/domain/action/tag');
const TagRepository = require('system/domain/repository/tag');
const TagModel = require('system/domain/entity/tag');
const TagDropdownItemTemplate = require('system/ui/template/tag/dropdown-item.hbs');

module.exports = Mn.View.extend({
    template: false,
    initialize: function(params) {
        _.bindAll(this, 'find', 'update', 'enter');
        this._el = params.el;
        this._context = params.context;
        this.onSelect = params.onSelect;
        this.onCreate = params.onCreate;
    },

    onRender: function() {
        new TypeaheadView({
            minLength: 0,
            el: this._el,
            find: this.find,
            update: this.update,
            enter: this.enter,
            itemView: TypeaheadView.DropdownItemView.extend({
                template: TagDropdownItemTemplate,
                className: 'list-item',
                activeClass: 'is-active'
            }),
            showOnFocus: true,
        });

        return this;
    },

    find: function(query) {
        return _.map(TagRepository.findTags({
            context: this._context,
            query: query
        }), function(t) {
            return t.clone();
        });
    },

    update: function(tag) {
        if(this.onSelect) {
            this.onSelect(tag);
        }
        return '';
    },

    enter: function(query) {
        const tags = TagRepository.findTags({
            context: this._context,
            query: query,
            options: {exact: true}
        });
        if(tags.length > 0) {
            if(this.onSelect) {
                this.onSelect(tags[0]);
            }
            return '';
        }

        // onCreate が存在しないならば Tag は作成しない
        if(!this.onCreate) {
            return '';
        }

        const tag = this._createTag(query);
        // tag が null の場合はエラー発生
        if(!tag) {
            return query;
        }

        TagAction.createTag(
            this._context.projectId,
            tag.id,
            tag.toJSON()
        )
            .then(_.bind(function() {
                this.onCreate(tag);
            }, this));
        return '';
    },

    _createTag: function(query, options) {
        // Tag を作成して validation
        const tag = new TagModel({
            id: Util.generateId(),
            name: query,
            color: Colors.pickRandom()
        }, {validate: true});
        if(tag.validationError) {
            Snackbar.error(tag.validationError);
            return;
        }

        // Tag の名前が被っていないかチェック
        const tags = TagRepository.findTags({
            context: this._context,
            query: query,
            options: {exact: true}
        });
        if(tags.length > 0) {
            Snackbar.error(
                i18n.t('diagram:alert.tag.duplicateName')
            );
            return;
        }

        return tag;
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/detail/tag-search.js